package com.example.mystybag.e5AiSearch.helpers

import com.example.mystybag.sharedmodels.project.responseModels.nomenclatures.SearchRankingConfigModel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

object SearchRankingRuntime {

    private val _configs =
        MutableStateFlow<Map<String, IntentTuning>>(emptyMap())

    val configs: StateFlow<Map<String, IntentTuning>> =
        _configs.asStateFlow()

    fun setFromServer(list: List<SearchRankingConfigModel>) {
        val map = list.associate { cfg ->
            cfg.categoryName to IntentTuning(
                penaltyMultiplier = cfg.intentPenalty.toFloat(),
                keywordWeight = cfg.keywordBoostPerHit.toFloat(),
                maxKeywordBonus = cfg.maxKeywordBoost.toFloat(),
                minCatScore = cfg.minCatScore.toFloat(),
                alpha = cfg.alphaCat.toFloat(),
                beta = cfg.betaLoc.toFloat(),
                preferredCategoryBoost = cfg.preferredCategoryBoost.toFloat(),
                preferredCategories = cfg.preferredCategories.toSet()
            )
        }
        _configs.value = map
    }

    fun resolve(intents: Set<SearchIntent>): IntentTuning {
        for (intent in intents) {
            val cfg = _configs.value[intent.name]
            if (cfg != null) return cfg
        }
        return _configs.value["DEFAULT"] ?: DEFAULT_TUNING
    }
}